import { AxiosInstance } from 'axios'
import { Rule, RuleIntrospection, RulePayload } from 'types/rules'
import { RULES_ENDPOINTS } from 'api/ApiRoutes'

class RulesApi {
  constructor(private axiosInstance: AxiosInstance) {}

  getTeamRules = async () => {
    const d = await this.axiosInstance.get<Rule[]>(RULES_ENDPOINTS.BASE)
    return d.data
  }

  getRuleIntrospection = async () => {
    const d = await this.axiosInstance.get<RuleIntrospection>(
      RULES_ENDPOINTS.RULES_INTROSPECTION
    )
    return d.data
  }

  createRule = async ({ rule }: { rule: RulePayload }) => {
    const d = await this.axiosInstance.post(RULES_ENDPOINTS.BASE, { rule })
    return d.data
  }

  deleteRule = async ({ ruleId }: { ruleId: Rule['token_id'] }) => {
    const d = await this.axiosInstance.delete(RULES_ENDPOINTS.RULE(ruleId))
    return d.data
  }

  editRule = async ({
    ruleId,
    rule
  }: {
    ruleId: Rule['token_id']
    rule: RulePayload
  }) => {
    const d = await this.axiosInstance.put(RULES_ENDPOINTS.RULE(ruleId), {
      rule
    })
    return d.data
  }
}

export default RulesApi
